const servers = {
  development: {
    ANCHOR_APPS: 'http://localhost:6544',
    ACQUISITIONS: 'http://localhost:6530',
    CONSTRUCTION: 'http://localhost:6547',
    CONTACTS: 'http://localhost:6546',
    CONTACTS_BACKEND: 'http://localhost:8006',
    FINANCES: 'http://localhost:6549',
    LEADS: 'http://localhost:6554',
    LOANS: 'http://localhost:6545',
    PHONE_SEARCH: 'http://localhost:6570',
    REPORTING: 'http://localhost:8080',
    TEXTING: 'http://localhost:6565',
    USERS: 'http://localhost:8001',
    SERVICING: 'http://localhost:7012',
    SERVICING_BACKEND: 'http://localhost:7011',
    DOCS_TEMPLATES: 'http://localhost:7013',
    REO: 'http://localhost:8095',
    FUNDING_CONDITIONS: 'http://localhost:7019',
  },
  testing: {
    ANCHOR_APPS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6544`,
    ACQUISITIONS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6530`,
    CONSTRUCTION: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6547`,
    CONTACTS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6546`,
    CONTACTS_BACKEND: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:8006`,
    FINANCES: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6549`,
    LEADS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6554`,
    LOANS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6545`,
    PHONE_SEARCH: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6570`,
    REPORTING: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:8081`,
    TEXTING: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:6565`,
    USERS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:8001`,
    SERVICING: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:7012`,
    SERVICING_BACKEND: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:7011`,
    DOCS_TEMPLATES: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:7013`,
    REO: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:8095`,
    FUNDING_CONDITIONS: `https://${process.env.VUE_APP_TEST_SERVER}.anchor-webapps.com:7019`,
  },
  staging: {
    ANCHOR_APPS: 'https://anchorapps.staging.anchor-webapps.com',
    ACQUISITIONS: 'https://acquisitions.staging.anchor-webapps.com',
    CONSTRUCTION: 'https://construction.staging.anchor-webapps.com',
    CONTACTS: 'https://contacts.staging.anchor-webapps.com',
    CONTACTS_BACKEND: 'https://contacts-backend.staging.anchor-webapps.com',
    FINANCES: 'https://finance.staging.anchor-webapps.com',
    LEADS: 'https://leads.staging.anchor-webapps.com',
    LOANS: 'https://loans.staging.anchor-webapps.com',
    PHONE_SEARCH: 'https://phonesearch.staging.anchor-webapps.com',
    REPORTING: 'http://reporting.staging.anchor-webapps.com',
    TEXTING: 'https://twilio.staging.anchor-webapps.com',
    USERS: 'https://users.staging.anchor-webapps.com',
    SERVICING: 'https://servicing.staging.anchor-webapps.com',
    SERVICING_BACKEND: 'https://servicing-backend.staging.anchor-webapps.com',
    DOCS_TEMPLATES: 'https://zkovmyzhe0.execute-api.us-west-2.amazonaws.com/staging',
    REO: 'https://reo.staging.anchor-webapps.com',
    FUNDING_CONDITIONS: 'https://funding-conditions.staging.anchor-webapps.com',
  },
  production: {
    ANCHOR_APPS: 'https://anchor-webapps.com',
    ACQUISITIONS: 'http://acquisitions.anchor-webapps.com',
    CONSTRUCTION: 'http://construction.anchor-webapps.com',
    CONTACTS: 'https://contacts.anchor-webapps.com',
    CONTACTS_BACKEND: 'https://contacts-backend.anchor-webapps.com',
    FINANCES: 'https://finance.anchor-webapps.com',
    LEADS: 'https://leads.anchor-webapps.com',
    LOANS: 'https://loans.anchor-webapps.com',
    PHONE_SEARCH: 'https://phonesearch.anchor-webapps.com',
    REPORTING: 'https://reporting.anchor-webapps.com',
    TEXTING: 'https://twilio.anchor-webapps.com',
    USERS: 'https://users.anchor-webapps.com',
    SERVICING: 'https://servicing.anchor-webapps.com',
    SERVICING_BACKEND: 'https://servicing-backend.anchor-webapps.com',
    DOCS_TEMPLATES: 'https://bu9l1zisz7.execute-api.us-west-1.amazonaws.com/production',
    REO: 'https://reo.anchor-webapps.com',
    FUNDING_CONDITIONS: 'https://funding-conditions.anchor-webapps.com',
  },
};

if (process.env.NODE_ENV === 'testing' && process.env.VUE_APP_K8S === 'k8s') {
  servers[process.env.NODE_ENV] = {
    ANCHOR_APPS: `https://anchorapps.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    ACQUISITIONS: `https://acquisitions.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    CONSTRUCTION: `https://construction.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    CONTACTS: `https://contacts.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    CONTACTS_BACKEND: `https://contacts-backend.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    FINANCES: `https://finance.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    LEADS: `https://leads.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    LOANS: `https://loans.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    PHONE_SEARCH: `https://phonesearch.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    REPORTING: `https://reporting.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    TEXTING: `https://twilio.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    USERS: `https://users.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    SERVICING: `https://servicing.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    SERVICING_BACKEND: `https://servicing-backend.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    DOCS_TEMPLATES: `https://docs-templates.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    REO: `https://reo.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
    FUNDING_CONDITIONS: `https://funding-conditions.${process.env.VUE_APP_TEST_SERVER}.dev.anchor-webapps.com`,
  };
}

export default servers[process.env.NODE_ENV];
